function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-120"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.69,348.43a2.32,2.32,0,0,1-.49.83c-3.54,3.35-18.65,7.07-31.63,9.75-10.75,2.23-20,3.74-20,3.74s-7.12-59.17-7.12-65.39-11.48-106.92-11.48-106.92l27.52-1.19L337,187.67s.22,2.69.59,7.39C340,225,348.28,336.62,343.69,348.43Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-120"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.68,175,400,194.34S374.23,272.55,369,282.25l-8.74,68.18s-46.84-2.06-68.38-8.57c0,0,13.62-71,14.35-80.47S326.68,175,326.68,175Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-120"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "233.62 166.73 223.92 331.48 128.63 328.35 136.15 202.11 138.49 162.91 180.01 164.58 233.62 166.73",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-120"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.93,167.09s-27.88,72,11.3,144.5S199.11,422.39,263.7,455.14s131.66,16.8,163.53-36.84-11.84-91.93-11.9-168.42,11.45-96.74-30-161.36-143.06-78.93-219.9-31S67.93,167.09,67.93,167.09Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.07,166.45c28.82-53.06,101.32-115,200.78-89.2S444.51,157.63,433.5,252.59,364.63,426.45,240,428.76,13.87,282.8,77.07,166.45Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.07,166.45c28.82-53.06,101.32-115,200.78-89.2S444.51,157.63,433.5,252.59,364.63,426.45,240,428.76,13.87,282.8,77.07,166.45Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Documents--inject-120"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 373.07,
    y: 242.94,
    width: 74.72,
    height: 49.06,
    rx: 4.54,
    transform: "translate(-36.09 65.94) rotate(-8.8)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.44,
    y1: 259.81,
    x2: 445.28,
    y2: 248.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.84,
    y: 262.16,
    width: 12.07,
    height: 17.38,
    transform: "translate(-36.32 69.72) rotate(-8.8)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.42,266c2.52-3,6.66-1,5.69,8.31l3.69,1.83.36,2.34-11.92,1.85-.49-3.13,4.5-1.75S430.05,268.83,432.42,266Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.55,287s8.62.07,6.15-1.65-2.84-3.46-.74-3.49,5.62,4,5.34,1.54,1.24-.86,1.53-.7,2.78-.84,2.9-.55-.05,1.1,8.06-.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.7,
    y1: 267.48,
    x2: 413.86,
    y2: 261.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 378.34,
    y1: 271.58,
    x2: 399.64,
    y2: 268.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 379.46,
    y1: 278.81,
    x2: 409.17,
    y2: 274.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.68,
    y1: 251.77,
    x2: 424.94,
    y2: 246.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.35 226.44 124.42 210.25 152.73 346.17 66.56 364.65 43.35 226.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.3,
    y1: 345.26,
    x2: 149.3,
    y2: 329.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.11,
    y1: 318.13,
    x2: 98.04,
    y2: 325.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.02,
    y1: 311.31,
    x2: 121.02,
    y2: 313.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.85,
    y1: 297.43,
    x2: 73.55,
    y2: 308.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.95,
    y1: 289.58,
    x2: 137.86,
    y2: 274.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "1,2"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.11,
    y1: 341.77,
    x2: 92.14,
    y2: 352.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.59,
    y1: 337.47,
    x2: 117.63,
    y2: 341.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.63,
    y1: 265.81,
    x2: 86.6,
    y2: 274.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.31,
    y1: 256.48,
    x2: 111.92,
    y2: 259.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.52,
    y1: 250,
    x2: 63.3,
    y2: 261.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.96,
    y1: 218.46,
    x2: 102.43,
    y2: 221.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.3,
    y1: 230.21,
    x2: 49.04,
    y2: 232.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.23,240.84a7.41,7.41,0,0,1,4-4.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.57,250A7.45,7.45,0,0,1,54,242.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.13,248.3A6.9,6.9,0,0,1,62.5,250",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.27,235.52a7.46,7.46,0,0,1,6.22,11.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.85,237.4c-1.33-.42-2.65-.9-4-1.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.19,238.36c-1.13,2.69-7.45.24-9.29-.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.37,231.22,88.19,234c-.19.79-.34,1.59-.49,2.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.52,234c1.26-3,.76-4,3.9-3.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-120"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.75,446.27l15.65,4.8-11.63-13.7a40.22,40.22,0,0,0,10.3-25.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.76,452.31a52.6,52.6,0,0,0,14.67-7.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.37,423.21c4.61,22.21,29.15,35.89,54.82,30.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.11,398.17a40.17,40.17,0,0,0-2.5,5.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.32,403.93c-4.6-22.21-29.15-35.89-54.81-30.56a51.42,51.42,0,0,0-29.72,17.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.09,395.79c-7.39-8.05-17.46-2.47-21.65,5.7-6.92-6-18.35-7.47-22.21,2.76-6.52,17.23,15.78,27.74,26.1,31.54,1.17.44,2.13.81,2.93,1.08.65-.55,1.41-1.25,2.33-2.09C196.75,427.41,213.55,409.37,201.09,395.79Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-120"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.54,68l-15.11-6.29,10.25,14.76A40.19,40.19,0,0,0,245,101.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,63.79a53,53,0,0,0-15.31,5.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.33,98.57C336.88,76,313.77,60,287.71,62.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.2,123.13a40.46,40.46,0,0,0,3-5.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,108.81c2.45,22.55,25.56,38.53,51.62,35.7a51.46,51.46,0,0,0,31.28-14.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291.93,
    cy: 101.71,
    r: 23.73,
    transform: "translate(-13.45 149.79) rotate(-28.16)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "282.91 104.69 290.01 111.39 301.85 91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hand-2--inject-120"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.59,327.71s-3.56,43.08,1.59,53.53,7.73,81.85,5.42,90.83c0,0,16.58,4.18,23.14-1.76s16.65-.22,33.27-6,4.63-134.07,4.63-134.07l.51-46.67-27.41-24.42Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.69,348.43a2.32,2.32,0,0,1-.49.83c-3.54,3.35-18.65,7.07-31.63,9.75-10.75,2.23-20,3.74-20,3.74s-7.12-59.17-7.12-65.39-11.48-106.92-11.48-106.92l27.52-1.19L337,187.67s.22,2.69.59,7.39C340,225,348.28,336.62,343.69,348.43Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-120)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.69,348.43,311.57,355l-12.13,2.49c-3.29-3.23-5.8-3.29-5.8-3.29l-1-9.05-1.57-14.81-13.82-130.3c3-2.07,4.48-6.6,4.48-6.6l18.5-.67,32.05-1.17,5.29,3.42C340,225,348.28,336.62,343.69,348.43Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.69,348.43,311.57,355l-12.13,2.49c-3.29-3.23-5.8-3.29-5.8-3.29l-1-9.05-1.57-14.81-13.82-130.3c3-2.07,4.48-6.6,4.48-6.6l18.5-.67,32.05-1.17,5.29,3.42C340,225,348.28,336.62,343.69,348.43Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.34 310.07 306.06 310.05 306.07 313.4 303.09 314.46 296.22 315.21 295.34 310.07",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296 316.97 303.88 316.7 305.9 317.66 305.8 322.11 296.6 322.21 296 316.97",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.26 324.08 306.26 323.43 306.16 326.8 301.81 328.34 297.21 328.08 297.26 324.08",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.8 329.76 305.07 330.13 305.73 331.99 304.67 334.04 298.17 334.46 297.05 331.29 297.8 329.76",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.18,336.27l1,2.91a2.18,2.18,0,0,1,0,2,1.65,1.65,0,0,1-1.52.54c-.56-.05-1.11-.24-1.67-.27-1.69-.07-3.24,1.32-4.9,1-.65-1.8-2.29-4.44-.07-5.25C299.43,337.07,306.42,336.93,306.18,336.27Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.15,344.46a16.41,16.41,0,0,1,.34,2.1,2.68,2.68,0,0,1-.74,2.51,3,3,0,0,1-1.39.37l-5.78.52a26.52,26.52,0,0,1-.05-3.28c.34-1.3.1-1.19,1.33-1.72C301.81,344.13,304.15,345.45,306.15,344.46Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.13,203s2.18,21.07,2.28,25.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 289.83,
    y1: 203.23,
    x2: 290.85,
    y2: 214.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.12 198.84 307.44 212.45 309.29 212.63 308.69 198.97 306.12 198.84",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.69,348.43a2.32,2.32,0,0,1-.49.83c-3.54,3.35-18.65,7.07-31.63,9.75v-9l-18.89-4.84-2.85-.73,1.28-14.08L296,276.56l4.27-83.75.18-3.56L337,187.67s.22,2.69.59,7.39C340,225,348.28,336.62,343.69,348.43Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.69,348.43a2.32,2.32,0,0,1-.49.83c-3.54,3.35-18.65,7.07-31.63,9.75-10.75,2.23-20,3.74-20,3.74s-7.12-59.17-7.12-65.39-11.48-106.92-11.48-106.92l27.52-1.19L337,187.67s.22,2.69.59,7.39C340,225,348.28,336.62,343.69,348.43Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.06,482.7c.23-2.11-3.09-32.38-3.15-35.67-.16-9-2.71-20.81-2.71-20.81-3.56-9.1-6.33-30.07-15.83-43.52S331.88,353.43,330.3,340s-1.19-12.27-.79-24.19A175.41,175.41,0,0,0,328.32,289c-.79-7.92-2.37-21.85,0-28.34s8.57-8,15.36-1.5,9.56,33.15,9.56,36.44,0,13.57,2.38,17.53c0,0,13.45-6.88,13.45-8.78s-.4-18.69,1.58-19.59l-7.91-25.6,15-5.33a39,39,0,0,1,7.24,8.7,46.94,46.94,0,0,1,4.23,8.49c6.33,16.79,16.5,28.5,18.6,33.33s0,43.19,0,50.32-4.6,40-4.48,45.53c.09,4,2.79,18.88,5.48,30.29,1,4.4,7.07,36.28,8,38.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.9,283.07c-.1,2.15,2.47,19.29,2.47,19.29,1.78,4.27-7.94,18.83-7.94,18.83-2.1,1.18-3,8.5-3,8.5-6.58-1.46-21.65-16.61-21.65-16.61S343,319.29,341,334.66s10.68,51.88,16.08,77.09S359.91,447,359.91,447c-.16-9-2.71-20.81-2.71-20.81-3.56-9.1-6.33-30.07-15.83-43.52S331.88,353.43,330.3,340s-1.19-12.27-.79-24.19A175.41,175.41,0,0,0,328.32,289c-.79-7.92-2.37-21.85,0-28.34s8.57-8,15.36-1.5,9.56,33.15,9.56,36.44,0,13.57,2.38,17.53c0,0,13.45-6.88,13.45-8.78s-.4-18.69,1.58-19.59l-7.91-25.6,15-5.33a39,39,0,0,1,7.24,8.7C380.13,272.23,375,281.73,374.9,283.07Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.12,402.85c.66-6,2.63-20.26,3.88-29.16-1.53,6.95-4,10.47-4,10.47s4.26-51,4.68-54.11,4.72-17.09,3.14-25.75c2.1,4.82,0,43.19,0,50.32s-4.6,40-4.48,45.53c.09,4,4.38,29.49,7.07,40.9C404.63,432.65,399.46,408.88,400.12,402.85Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.79,469.25c-3.16-9.1-13.31-63.6-13.43-69.1s4.48-38.41,4.48-45.53,2.1-45.5,0-50.32-12.27-16.54-18.6-33.33a43.66,43.66,0,0,0-11.47-17.19l-15,5.33,7.91,25.6c-2,.9-1.58,17.69-1.58,19.59s-13.45,8.78-13.45,8.78c-2.38-4-2.38-14.24-2.38-17.53s-2.77-29.95-9.56-36.44-13-5-15.36,1.5-.79,20.42,0,28.34a175.41,175.41,0,0,1,1.19,26.84c-.4,11.92-.8,10.74.79,24.19s1.58,29.27,11.07,42.72,12.27,34.42,15.83,43.52c0,0,6.72,48.57,5.86,56.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.62,313.08s2.37,11.07,7.71,16.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.06,318.13s10,3.06,14.18,3.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.07,304.3s7.12-3.29,11.67-1.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.65,284.71s5.54-.51,6.72-3.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.2,385.52s10.64,13.21,13.8,19.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.07,327.71c-1.78,10.49-4.16,39.17-4.95,44.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.47,307.93c.3,9.5-2,14.44-2,14.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.68,175,400,194.34S374.23,272.55,369,282.25l-8.74,68.18s-46.84-2.06-68.38-8.57c0,0,13.62-71,14.35-80.47S326.68,175,326.68,175Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-120)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.91,257.19l16.16-69.09s6.95-3.45,9.64-6.6l52.53,14.94s.16,5.15,3.17,8.45L365.9,281.28l-6.43,56.31s-8.55.68-9.37,7c0,0-27.72,1.5-46.31-3.4,0,0-2.19-6.83-5.54-11.15Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.91,257.19l16.16-69.09s6.95-3.45,9.64-6.6l52.53,14.94s.16,5.15,3.17,8.45L365.9,281.28l-6.43,56.31s-8.55.68-9.37,7c0,0-27.72,1.5-46.31-3.4,0,0-2.19-6.83-5.54-11.15Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.36,260.78s4.77-18,21.57-14.77,7.31,25.41,7.31,25.41.1,17.9-13.53,15.43C327.89,284.71,321.59,278.22,324.36,260.78Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.46,194.67s-5.08,20.57-6.39,24.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.81,
    y1: 196.45,
    x2: 334.85,
    y2: 207.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.9 204.36 385.01 207.92 383.9 211.09 380.74 211.09 374.01 209.51 374.9 204.36",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.22 211.09 380.74 213.46 382.32 215.04 380.74 219.2 372.03 216.23 373.22 211.09",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.03 218.21 380.74 220.61 379.51 223.75 374.9 223.75 370.65 221.97 372.03 218.21",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.65 223.75 377.37 226.52 377.37 228.49 375.69 230.08 369.43 228.3 369.43 224.93 370.65 223.75",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.38,232.68v3.08a2.2,2.2,0,0,1-.61,1.88,1.69,1.69,0,0,1-1.62,0c-.51-.24-1-.6-1.48-.81-1.57-.63-3.5.16-5-.68,0-1.91-.67-4.94,1.69-5C369.75,231.18,376.38,233.38,376.38,232.68Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.61,240.39a14.52,14.52,0,0,1-.38,2.09c-.22.89-.65,1.88-1.54,2.12a2.92,2.92,0,0,1-1.43-.12L364.64,243a27.5,27.5,0,0,1,1-3.1c.76-1.11.5-1.09,1.83-1.18C369.63,238.63,371.39,240.66,373.61,240.39Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.63 197.84 351.26 211.09 352.94 211.88 357 198.82 354.63 197.84",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.4 286.82 322.78 289.51 321.94 292.75 318.79 293.03 311.95 292.02 312.4 286.82",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.3 293.67 318.99 295.39 320.71 296.83 319.49 301.11 310.56 298.89 311.3 293.67",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.73 300.87 319.61 302.51 318.65 305.74 314.06 306.14 309.67 304.73 310.73 300.87",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.82 306.5 316.76 308.69 316.93 310.66 315.39 312.38 309 311.14 308.71 307.79 309.82 306.5",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.29,314.91l.27,3.07a2.19,2.19,0,0,1-.45,1.93,1.67,1.67,0,0,1-1.61.13c-.53-.19-1-.51-1.55-.67-1.61-.5-3.47.45-5-.26-.18-1.9-1.09-4.86,1.25-5.09C309.56,314,316.35,315.61,316.29,314.91Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.2,322.83A15.06,15.06,0,0,1,314,325c-.15.9-.49,1.93-1.35,2.24a2.92,2.92,0,0,1-1.44,0l-5.72-1a27.16,27.16,0,0,1,.77-3.18c.66-1.17.4-1.13,1.72-1.33C310.08,321.42,312,323.29,314.2,322.83Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.62,332.54S358,306,358,303.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.87,331.35s1-13.8,1.18-16.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.32 321.38 329.11 337.09 332.32 337.09 334.65 321.38 332.32 321.38",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.17,281.86c-6.94-1.45-13.13-3.58-17.71-6.65,0,0,3.32,9.54,15.09,25.8l-6.33,49.42s-30.57-1.34-53.67-5.29c7.1-20,20-57.9,18.47-65.41-2.07-10.31,5.24-22.48,5.24-22.48,23.11-4.16,45.52-21.63,60.9-36.4C383.33,244,372.64,275,369.17,281.86Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.68,175,400,194.34S374.23,272.55,369,282.25l-8.74,68.18s-46.84-2.06-68.38-8.57c0,0,13.62-71,14.35-80.47S326.68,175,326.68,175Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.33,330.69,357,405.45c-2.3-4.89-8.57-13.23-11.81-17.4-1.2-1.56-2-2.53-2-2.53l-1.83-2.82c-9.49-13.45-9.49-29.27-11.07-42.72s-1.19-12.27-.79-24.19A175.41,175.41,0,0,0,328.32,289c-.79-7.92-2.37-21.85,0-28.34,1.16-3.18,3.25-5.16,5.87-5.58s6,.78,9.49,4.08c6.79,6.49,9.56,33.15,9.56,36.44s0,13.57,2.38,17.53C355.62,313.08,362,325.15,367.33,330.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.58,377.37c2.16,2.76,3.63,6.74,4.61,10.68-1.2-1.56-2-2.53-2-2.53l-1.83-2.82c-9.49-13.45-9.49-29.27-11.07-42.72s-1.19-12.27-.79-24.19A175.41,175.41,0,0,0,328.32,289c-.79-7.92-2.37-21.85,0-28.34,1.16-3.18,3.25-5.16,5.87-5.58,5,1.42,10,6.51,11.74,15.22,3,14.62-10.53,2.81-13.66,15.2s1.42,15.73,3.29,18.85-.52,10-3.29,19.24S334.65,369.78,340.58,377.37Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.33,330.69c-5.34-5.54-11.71-17.61-11.71-17.61-2.38-4-2.38-14.24-2.38-17.53s-2.77-29.95-9.56-36.44-13-5-15.36,1.5-.79,20.42,0,28.34a175.41,175.41,0,0,1,1.19,26.84c-.4,11.92-.8,10.74.79,24.19s1.58,29.27,11.07,42.72l1.83,2.82s10.64,13.21,13.8,19.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.32,299.05s9.07-4.69,13.61-4.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hand-1--inject-120"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.81,170.81S170.87,145.55,169.29,144s-2.77-28.49-7.13-40.35-6.47-81.5-6.47-81.5-4.15-5.14-15.85-2.37-23.17-2.38-36.22,5.14S115.88,140,115.88,140l25.69,81.87Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.57,171s-10.28,65.67-21,74.37c-6.19,5-15.84,7.3-24.4,7-6.2-.22-11.84-1.78-15.16-4.61-7.91-6.73-19-10.29-24.52-14.64s-5.54-19.78-9.1-32.84-8.71-13.45-9.89-26.5-5.94-53-14.54-64.09-8.8-19.78-12.36-31.06S49,26.54,49,26.54l63.48-13s6.24,25.83,12.92,46.9c3.17,10,6.44,18.94,9.18,23.52a196.78,196.78,0,0,1,13.63,27.69c7.18,7.52,11.11,24.18,12.3,38.77h0l17,9.48C190.58,163.47,209.57,171,209.57,171Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.57,171s-10.28,65.67-21,74.37c-6.19,5-15.84,7.3-24.4,7-20.3-5-25.76-16.32-28.51-19.06-3.66-3.65-8.47-25.89-5.83-38.83s.74-17.73-1.44-24.05c-4.83-14,9.9-21.54,11.42-26.84s1-34.94-5.63-44.58c-3.52-5.13-12.59-31.57-8.77-38.55,3.17,10,6.44,18.94,9.18,23.52a196.78,196.78,0,0,1,13.63,27.69c7.18,7.52,11.11,24.18,12.3,38.77h0l17,9.48C190.58,163.47,209.57,171,209.57,171Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.05,166.38s-3.58,4.21-6.74,4.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.84,180.61s-3.85,8.18-10,10",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,228.55s8.71-3.76,10.09-10.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.53,159.91s-2.18,2.77-2.18,5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.52,13.54S126.1,69.71,134.62,84a196.78,196.78,0,0,1,13.63,27.69c7.18,7.52,11.11,24.19,12.3,38.78h0l17,9.48c13.05,3.56,32,11.08,32,11.08s-10.28,65.67-21,74.37S157,254.46,149,247.74s-19-10.29-24.52-14.64-5.54-19.78-9.1-32.84-8.71-13.45-9.89-26.5-5.94-53-14.54-64.09-8.8-19.78-12.36-31.06S49,26.54,49,26.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.62 166.74 128.63 328.35 153.41 331.11 228.7 334.24 236.41 190.49 233.62 166.74",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.62 166.73 223.92 331.48 128.63 328.35 136.15 202.11 138.49 162.91 180.01 164.58 233.62 166.73",
    style: {
      fill: "#757575"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-120)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 209.66,
    cy: 300.91,
    r: 11.6,
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.39,
    y1: 293.21,
    x2: 214.25,
    y2: 294.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.28,
    y1: 295.12,
    x2: 216.09,
    y2: 296.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.97,
    y1: 306.76,
    x2: 214.79,
    y2: 307.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.14,297.75a1.3,1.3,0,0,0,1.56-.89l.88.09-.89,8.35-1.31-.14.68-6.37-1-.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.51,298.1c.52,0,.76.39.7.94v.1l-.51-.05V299c0-.24-.06-.35-.23-.37s-.28.07-.3.31.06.45.38.79a1.34,1.34,0,0,1,.47,1.13c-.06.55-.36.83-.89.77s-.76-.4-.71-.94l0-.21.5.05,0,.25c0,.24.07.34.24.36s.29-.06.31-.3-.06-.45-.38-.79a1.34,1.34,0,0,1-.47-1.13C211.69,298.32,212,298,212.51,298.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.45,298.24l1.66.17-.06.49-.56-.06-.31,2.92-.53-.05.31-2.93-.56-.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.19,
    y: 171.85,
    width: 20.82,
    height: 13.65,
    rx: 0.89,
    transform: "translate(42.09 -33.11) rotate(12.31)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,181.42l-.07-.07s0-.12-.05-.17a.1.1,0,0,0,0,0,.46.46,0,0,1-.11-.16.14.14,0,0,1,0-.06s.05,0,.08-.07a.19.19,0,0,0,.09-.14.11.11,0,0,1,0-.05l.06,0a.06.06,0,0,0,0,0c0-.19-.12-.33-.24-.48-.29-.36-.35-.54-.29-.78s.16-.31.33-.28.24.15.19.39l0,.14.5.11,0-.11a.74.74,0,0,0-.39-.94l.06-.24-.43-.1-.05.25c-.39,0-.64.25-.74.7a1.2,1.2,0,0,0,.37,1.11c.29.35.35.55.29.78s-.17.31-.34.27-.25-.15-.2-.38l.06-.27-.5-.11,0,.23a.75.75,0,0,0,.39,1l0,.24.43.1.05-.25.26,0a.57.57,0,0,0,.21-.13.8.8,0,0,0,.15-.21C170,181.48,170,181.45,170,181.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.75,181.26a.6.6,0,0,0-.06-.23.25.25,0,0,1,0-.12.16.16,0,0,1,.07-.07c.27-.24-.06-.56-.32-.62a.54.54,0,0,0-.51.14l.21-.78.92.2.1-.48-1.38-.3a.83.83,0,0,0-.06.21c0,.07.09.09.09.17s0,.07,0,.11a.25.25,0,0,0,.11.14c.05,0,.1.09.09.15a.09.09,0,0,1,0,.06.46.46,0,0,1-.19.22.17.17,0,0,0-.1.06v.06c0,.07-.08.11-.14.15s-.21.36-.27.58l.5.11,0-.1c.05-.24.18-.3.34-.27s.26.15.2.39l-.16.74c0,.23-.17.3-.34.26s-.25-.14-.2-.38l.07-.31-.5-.11-.06.28a.81.81,0,1,0,1.57.34A2.09,2.09,0,0,0,172.75,181.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.28,182.66a.86.86,0,0,0-.06-.23.25.25,0,0,1,0-.12.16.16,0,0,1,.07-.07c.26-.24-.07-.56-.32-.62a.54.54,0,0,0-.51.14l.21-.78.92.2.1-.48-1.38-.3a.56.56,0,0,0-.06.21c0,.07.08.09.09.17s0,.07,0,.11a.25.25,0,0,0,.11.14c.05,0,.1.09.09.15s0,0,0,.06a.43.43,0,0,1-.2.22.18.18,0,0,0-.09.06s0,0,0,.06-.07.11-.13.15-.21.36-.27.58l.5.11,0-.1c.05-.24.18-.3.34-.27s.25.15.2.39l-.16.74c0,.23-.17.3-.34.26s-.25-.14-.2-.38l.07-.31-.5-.11-.06.28a.8.8,0,1,0,1.56.34A1.81,1.81,0,0,0,179.28,182.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.89,180.27c.05-.24.18-.31.34-.27a.22.22,0,0,1,.19.21l.17,0h0a.06.06,0,0,1,0,0,.21.21,0,0,0,.1.14c.06.05.14.08.21.13a.78.78,0,0,0-.6-1,.76.76,0,0,0-1,.67,1.29,1.29,0,0,0,0,.19c0,.16,0,.11.16.17s.21.14.07.19l0,0s0,0,0,0l.09,0s0,.07,0,.1,0,.05-.05.09a.12.12,0,0,1,0,.08h0s-.08.13-.1.15a.34.34,0,0,1-.12.12c-.13.08-.19,0-.23.2s-.05.22-.07.32a.82.82,0,1,0,1.59.35l.16-.7h-.06a2.27,2.27,0,0,1-.34-.19l-.09-.08-.2.9c0,.24-.18.31-.34.27s-.25-.15-.2-.39l.29-1.36a.39.39,0,0,1,.06-.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.35,181.92l.05,0c0-.05,0-.1,0-.17l.22,0,.17-.77a.82.82,0,1,0-1.59-.35l0,.14c.07.06.11.16.18.21s.18,0,.15.17-.06.14,0,.19.07,0,.08.07a.09.09,0,0,1,0,.11s-.07,0-.08.09,0,.15-.06.17-.19-.12-.3-.11a.23.23,0,0,0-.16.17,3.21,3.21,0,0,0-.11.52.76.76,0,0,0,.61,1,.8.8,0,0,0,.67-.12,1,1,0,0,0,.22-.27.28.28,0,0,0,0-.37s0,0,0,0,0,0,0,0a0,0,0,0,1-.05,0l-.07-.24s0,0,0,0,0,0,.07-.06,0-.19.1-.26S176.33,181.94,176.35,181.92Zm-.42.68c-.05.24-.18.31-.35.27s-.25-.15-.2-.39l.4-1.8c.05-.24.17-.31.34-.27s.25.15.2.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.24,183.16l-.11.51-.51-.11.11-.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.42,182.27c.06,0,.06-.23.08-.31a.82.82,0,1,0-1.59-.35l-.15.67c.13.12,0,.31.06.45s0,0,0,.06-.15.09-.15.17,0,0,0,0-.08.12-.13.18a.3.3,0,0,0-.05.16.82.82,0,1,0,1.59.35l.12-.55c0-.14.18-.51,0-.62s-.08,0-.1-.07a.16.16,0,0,1,0-.15C181.22,182.16,181.31,182.33,181.42,182.27Zm-.61.88c0,.06-.1.08-.15.16a1.08,1.08,0,0,0-.07.31c-.05.24-.18.3-.34.27s-.26-.15-.2-.39c0-.07.09-.27.07-.33s-.1,0-.14-.12a.58.58,0,0,1,0-.32.17.17,0,0,0,0-.07s-.05-.09,0-.13,0,0,0,0,0-.13,0-.22,0,0,0,0c.32.12.31-.37.36-.57s.18-.31.34-.27.25.15.2.38a2.41,2.41,0,0,0-.12.63.19.19,0,0,1,.16.17.43.43,0,0,0,0,.16s0,.09,0,.13-.06,0-.1,0a.18.18,0,0,0-.11.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.83,175l3.38.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.15,173.32l6,1.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.65,
    y1: 175.64,
    x2: 171.61,
    y2: 176.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,326.89a66.47,66.47,0,0,1,16.09-2.16c9.76-.24,16,1.61,24-2.35s13.19,3.17,20.84-.79,11.2-10.3,15.62-10.16,11-70.69,13.12-82.88,6.63-46.17,8.18-53.07l-8.71,153.57Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.42 296.67 157.81 326.34 132.05 324.74 133.42 296.67",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.15,238l-.39,11.29a12,12,0,0,1-12.41,11.58l-11.6-.41A12,12,0,0,1,162.17,248l.52-14.7a12,12,0,0,1,12.41-11.57l11.6.4c.32,0,.64,0,1,.07A9.63,9.63,0,0,0,198.15,238Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.24,228.25a5.49,5.49,0,1,1-5.3-5.67A5.5,5.5,0,0,1,200.24,228.25Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.47,249.4l17.05-14.58s-2.16-7.81,0-10.28l-8.19,0a7.74,7.74,0,0,0-7.75,7.25Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.43,228.55l3.65-4s-2.27-1.53-3.65,0S192.43,228.55,192.43,228.55Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.65,
    y1: 315.66,
    x2: 218.14,
    y2: 316.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.13,
    y1: 318.43,
    x2: 218.14,
    y2: 320.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.45,
    y1: 326.34,
    x2: 218.14,
    y2: 326.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.76,225.37c-14.18,6.82-29.54-17.07-34.92-20.36a22.83,22.83,0,0,1-3.69-2.9l2.34-39.2L180,164.58c-.27,5.84-.18,12.29,1.12,16C183.92,188.67,188.93,218.56,174.76,225.37Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.87,226.59s11.34,4.92,16.48,2,10.68-8.5,11.47-20.89c0,0,6.75,17.45-6.86,22.68S158.87,226.59,158.87,226.59Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.45,233.57s23,6.18,32.84-5c0,0-1.32,6.21-11.94,8S154.45,233.57,154.45,233.57Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.44,193.62c-1.75-3.11.4,24.84.4,24.84S195,200,191.44,193.62Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "233.62 166.73 223.92 331.48 128.63 328.35 136.15 202.11 138.49 162.91 180.01 164.58 233.62 166.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.8 332.36 225.33 331.48 233.62 180.61 235.09 190.57 228.8 332.36",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.76,225.37a9.37,9.37,0,0,1-8.54.13,12.25,12.25,0,0,1-5.31-5.46c-3.95-7.12-14.64-23.34-16.61-28s-6.33-17.84-10.68-23.37-6.73-13.85-6.73-13.85l-1.58-80.7c2.37,11.67,8.9,24.92,8.9,24.92a37.36,37.36,0,0,1,14,12.66,23.36,23.36,0,0,1,2.73,3.53c6.46,10,9.59,28,9.93,42,.4,15.83,5.54,23,13.85,36.79S180.16,222.3,174.76,225.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.76,225.37a9.59,9.59,0,0,1-8.54.13c4.54-1.24,10.5-3.57,9.13-7-2.15-5.48-8.44,2.65-11.6,0s-14.64-17.85-7.35-24.54,5-17.91,0-21.07-1.75-10.69-.17-22.54c1-7.17-2.43-23.41-5.25-35.13,6.46,10,9.59,28,9.93,42,.4,15.83,5.54,23,13.85,36.79S180.16,222.49,174.76,225.37Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.31,74.07c2.37,11.67,8.9,24.92,8.9,24.92a37.36,37.36,0,0,1,14,12.66c8.31,8.7,12.27,29.67,12.66,45.49s5.54,23,13.85,36.79,6,28.17,0,31.44c-4.18,2.29-9.89,1.79-13.85-5.33s-14.64-23.34-16.61-28-6.33-17.84-10.68-23.37-6.73-13.85-6.73-13.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,190.57s6.46-.58,9.42-3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.52,156.41s-1.26,3,5.34,6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.020ee4565280f143f90e56462ff06ac9.svg";
export { ForwardRef as ReactComponent };